import { loadMessages } from "@progress/kendo-react-intl";
export const loadAppMessages = async (): Promise<void> => {
    
  try {
    let clientCode=localStorage.getItem("UserClientCode");
    const messages = await import(`./Labels/en/${clientCode}/Labels.json`);
    console.log("Loaded messages:", messages.default || messages);
    loadMessages(messages.default || messages, "en");
  } catch (e) {
    console.warn('Fallback to default labels');
    const fallback = await import(`./Labels/en/Global/Labels.json`);
    console.log("fallback messages:", fallback.default || fallback);
    loadMessages(fallback.default || fallback, "en");
  }
};